import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/leases-history",
      name: "home",
      component: () =>
        import("./pages/web/LeasesHistory.vue")
    },
    {
      path: "/banks",
      name: "edit",
      component: () =>
        import("./pages/web/Banks.vue")
    },
    {
      path: "/bills",
      name: "bills",
      component: () =>
        import("./pages/web/Bills.vue")//缴费账单
    },
    {
      path: "/orders",
      name: "orders",
      component: () =>
        import("./pages/web/Order.vue")//明细对账
    },
    {
      path: "/housetypes",
      name: "housetypes",
      component: () =>
        import("./pages/web/HouseType.vue")//房源类型
    },

    {
      path: "/importlogs",
      name: "importlogs",
      component: () =>
        import("./pages/web/Importlogs.vue") //导入记录
    },
    {
      path: "/wallets",
      name: "wallets",
      component: () =>
        import("./pages/web/Wallet.vue")//用户余额
    },
    {
      path: "/reviewrules",
      name: "reviewrules",
      component: () =>
        import("./pages/web/ReviewRules.vue")//审核规则
    },
    {
      path: "/reviewrecords",
      name: "reviewrecords",
      component: () =>
        import("./pages/web/ReviewRecords.vue")
    },{
      path: "/refundrecords",
      name: "refundrecords",
      component: () =>
        import("./pages/web/RefundRecords.vue")
    },
    {
      path: "/bills-phone",
      name: "bills-phone",
      component: () =>
        import("./pages/phone/BillsPhone.vue")
    },
    {
      path: "/meters",
      name: "meters",
      component: () =>
        import("./pages/web/Meters.vue")//水电抄表
    },
    {
      path: "/user-info",
      name: "user-info",
      component: () =>
        import("./pages/web/UserInfo.vue")
    },
    {
      path: "/file-upload",
      name: "file-upload",
      component: () =>
        import("./pages/web/FileUpload.vue")
    },
    {
      path: "/lease-detail",
      component: () =>
        import("./pages/web/LeaseDetail.vue")
    },
    {
      path: "/lease-detail-phone",
      component: () =>
        import("./pages/phone/LeaseDetailPhone.vue")
    },
    {
      path: "/lease-detail-phone-new",
      component: () =>
          import("./pages/phone/pay/List.vue")
    },
    {
      path: "/phone-edit",
      name: "phoneHome",
      component: () =>
        import("./pages/phone/PhoneEdit.vue")
    },
    {
      path: "/area-edit",
      component: () =>
          import("./pages/web/AreaEdit.vue")
    },
    {
      path: "/contract",
      component: () =>
          import("./pages/web/Contract.vue")//合同检索
    },
    {
      path: "/drawing",
      component: () =>
          import("./pages/web/Drawing.vue")
    },
    {
      path: "/count",
      component: () =>
          import("./pages/web/Count.vue")
    },
    {
      path: "/countnew",
      component: () =>
          import("./pages/web/CountNew.vue")
    },
    {
      path: "/synclogs",
      name: "synclogs",
      component: () =>
        import("./pages/web/HouseSyncLogs.vue")//公租房同步日志
    },
    {
      path: "/devices/aptlock",
      name: "aptlock",
      component: () => import("./pages/web/aptlock.vue") // 智能门锁详情
    },
    {
      path: "/account",
      name: "account",
      component: () => import("./pages/phone/account.vue") // 用户账户
    },
    {
      path: '/key/manage',
      component: () => import('./pages/phone/key/manage/List.vue')
    }, {
      path: '/key/share',
      component: () => import('./pages/phone/key/share/Share.vue')
    }, {
      path: '/key/record',
      component: () => import('./pages/phone/key/record/List.vue')
    },{
      path: '/repair/list',
      component: () => import('./pages/phone/repair/List.vue')
    },{
      path: '/appointment',
      component: () => import('./pages/phone/appointment/List.vue')
    },{
      path: '/card',
      component: () => import('./pages/phone/card/List.vue')
    },{
      path: '/activity',
      component: () => import('./pages/phone/activity/List.vue')
    },{
      path: '/pay',
      component: () => import('./pages/phone/pay/List.vue')
    },{
      path: '/lease',
      component: () => import('./pages/phone/lease/List.vue')
    },{
      path: '/coupon',
      component: () => import('./pages/phone/coupon/List.vue')
    },{
      path: '/confirm',
      component: () => import( './pages/phone/confirm/index.vue')
  },
  // 积分兑换
  {
    path: '/integral', 
    component: () => import(   './pages/phone/integral/index.vue')
  },
  {
    path: '/phoneList', 
    name: 'phoneList',
    component: () => import(  './pages/phone/integral/PhoneList.vue')
  },
    //充值选择 
    {
        path: '/charge/select',
        component: () => import(/* webpackChunkName: "about" */ './pages/phone/charge/Select.vue')
    },
    //充值支付
    {
        path: '/charge/pay',
        component: () => import(/* webpackChunkName: "about" */ './pages/phone/charge/Pay.vue')
    },
    //我的管家
    {
        path: '/steward',
        component: () => import(/* webpackChunkName: "about" */ './pages/phone/count/Manage.vue')
    },

    // {
    //   path: "/employee/keyauth",
    //   name: "empauth",
    //   component: () => import("./pages/web/empauth.vue") // 员工门锁授权
    // }
  ]
});
